/* global Ladda */
(function ($) {
    'use strict';
    const keyCodes = {
        Enter: 13
    };
    $.widget("fd.control_tags", {
        options: {
            parentid: null,
            callback: function () { },
            rendertofield: null,
            provider: null,
            tagstype: null,
            ajaxbuilder: null,
            namespace: 'Page',
            tagmaxcount: null,
            allownew: true,
            allowmultiple: true,
            minimuminputlength: 1
        },
        _create: function () {
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }
            var $element = this.element;
            var options = this.options;
            var self = this;
            var select2OptionsAjax;

            if (this.options.provider) {
                select2OptionsAjax = {
                    delay: 350,
                    url: options.provider,
                    dataType: "json",
                    data: function (data, page) {
                        return {
                            term: data.term
                        };
                    },
                    results: function (data, page) {
                        return {
                            results: data
                        };
                    }
                };
            } else if (this.options.ajaxbuilder && typeof (FD[this.options.namespace][this.options.ajaxbuilder]) === 'function') {
                select2OptionsAjax = FD[this.options.namespace][this.options.ajaxbuilder].call(this);
            }
            var select2Options = {
                multiple: this.options.allowmultiple,
                tags: true,
                minimumInputLength: this.options.minimuminputlength,
                language: {
                    inputTooShort: function () {
                        return (+self.options.minimuminputlength) + ' characters needed';
                    }
                },
                createSearchChoice: function (term, data) {
                    if ($(data).filter(function () {
                        return this.text.localeCompare(term) === 0;
                    }).length === 0) {
                        return {
                            id: term,
                            text: term
                        };
                    }

                    return {
                        id: "",
                        text: ""
                    };
                },
                createTag: function (params) {
                    if (!self.options.allownew)
                        return undefined;

                    var term = $.trim(params.term);

                    if (term === '') {
                        return null;
                    }

                    return {
                        id: self._getNewTagId(term),
                        text: term + '*'
                    };
                },
                ajax: select2OptionsAjax
            };

            this.element[0].fdUnselect = function () {
                self._fdUnselect(select2Options);
            };

            this.element[0].fdResetSelectedItem = function (item) {
                self._fdResetSelectedItem(select2Options, item);
            };

            if (options.tagmaxcount)
                select2Options.maximumSelectionLength = options.tagmaxcount;

            $element.select2(select2Options);

            this._setEvents();
            this.element.trigger('change');
        },
        _fdResetSelectedItem: function (select2Options, item) {
            item = typeof item === 'string' ? { id: item, text: item } : item;
            var html = item ? '<option value="' + item.id + '" selected>' + item.text + '</option>' : '';

            this.element
                .select2('destroy')
                .html(html)
                .select2(select2Options)
                .trigger('change');
        },
        _fdUnselect: function (select2Options) {
            const selectOption = select2Options.multiple ?
                "" :
                '<option value="" selected>-- Select --</option>';
            this.element
                .select2('destroy')
                .html(selectOption)
                .select2(select2Options)
                .trigger('change');
        },
        _getNewTagId: function (term) {
            if (this.options.tagstype === 'text')
                return term;

            this.generatedId = this.generatedId === null || this.generatedId === undefined ? 0 : this.generatedId;
            this.generatedId -= 1;
            return this.generatedId;
        },
        _setEvents: function () {
            this.element.off('change.fdcontrol').on('change.fdcontrol', this._handleChange.bind(this));
        },
        _renderSelectedOptionsAsJson(element) {
            const options = this.options;
            const jsonItems = [];
            var selectItems = $(element).find("option");
            for (let i = 0; i < selectItems.length; i++) {
                const item = selectItems[i];
                if (item.selected)
                    jsonItems.push({ id: item.value, name: item.text });
            }
            const json = JSON.stringify(jsonItems);
            $("#" + options.rendertofield).val(json);
        },
        _handleChange: function (event) {
            this._renderSelectedOptionsAsJson(event.target);
            this._runCallback(event);
        },
        _runCallback: function (event) {
            this.options.callback.call(this, {
                parentid: this.options.parentid,
                value: this.element.val(),
                valueElement: this.element.find('option:selected')
            }, event);
        },
    });
}(jQuery));